import React, { useEffect, useRef } from 'react';

const JWPlayer = (props) => {
  const videoRef = useRef();

    function installPlayerScript({ context, onLoadCallback, scriptSrc }) {
      const jwPlayerScript = context.createElement('script');
        jwPlayerScript.id = "jwPlayerLibrary"  
        jwPlayerScript.src = scriptSrc;
        jwPlayerScript.onload = onLoadCallback;    
        context.body.appendChild(jwPlayerScript);
    }
    function setJWPlayerDefaults ({ context, playerId })  {
        const playerConfigs = context.__JW_PLAYER_CONFIGS__ = (context.__JW_PLAYER_CONFIGS__ || {});
        const existingConfig = playerConfigs[playerId];
      
        if (existingConfig) {
          context.jwplayer.defaults = existingConfig;
        } else {
          playerConfigs[playerId] = context.jwplayer.defaults;
        }
    };    
    useEffect(()=> {
        const existingLibraryScript = document.getElementById("jwPlayerLibrary")
        if (existingLibraryScript) {
            existingLibraryScript.addEventListener("load" ,
            _initialize
          )
        }
        if (!existingLibraryScript) {
            installPlayerScript({
              context: document, 
              onLoadCallback: _initialize,
              scriptSrc: props.playerScript,
            });
          } 
    }, [])
    useEffect(() => {
      if (window.jwplayer && window.jwplayer(videoRef.current)) {
      _initialize();
      }
    })
    function initialize({player, playerOpts }) {
        player.setup(playerOpts);

        // Deshabilita los controles mientras se reproduce la publicidad
        player.on('adPlay', function() {
          player.setControls(false);
        });

        // Rehabilita los controles cuando se devuelve el control al contenido principal
        const restoreControls = function() {
          player.setControls(true);
        };

        // Se cubren todos los escenarios de salida para asegurar que los controles vuelvan
        player.on('adComplete', restoreControls);
        player.on('adSkipped', restoreControls);
        player.on('adError', restoreControls);
    }
    function _initialize() {

      window.removeEventListener("load", _initialize)
      
      setJWPlayerDefaults({ context: window, player: props.playerId });
      
        const player = window.jwplayer(videoRef.current);
        
        const playerOpts = {file: props.file, image: props.thumbnail};
    
        initialize({ player, playerOpts });
    }
    return (
        <div style={{ position: 'relative', width: '100%', aspectRatio: '16 / 9' }}>
            <div id={props.playerId} ref={videoRef} style={{ width: '100%', height: '100%' }} />
        </div>
    )
}

export default JWPlayer;